var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a-tooltip',{attrs:{"placement":"bottom"}},[_c('template',{slot:"title"},[_vm._v(" "+_vm._s(_vm.isFullscreen ? 'Exit Full Screen' : 'Change to Full Screen')+" ")]),_c('a-icon',{style:({ fontSize: '20px' }),attrs:{"type":_vm.isFullscreen ? 'fullscreen-exit' : 'fullscreen'},on:{"click":_vm.click}})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }